import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { MyLink } from '@/src/components/AppComponents/MyLink/MyLInk';
import { ROUTES } from '@/src/utils/routes';
import styles from './Navigation.module.scss';
import { NavigationProps, useNavigation } from './useNavigation';
import { isWebsiteDApp } from '@/src/utils/constants';
import classNames from 'classnames';

export default function Navigation(props: NavigationProps) {
    //--------------------------------------
    const { session, status, appStore, walletStore, onClick, pathname, isRefreshing, setIsRefreshing, loaderPosition, containerRef , loaderRef} = useNavigation(props);
    //--------------------------------------
    return (
        <div className={styles.navGroup} ref={containerRef}>
            <MyLink href={ROUTES.HOME}>
                <div
                    className={styles.navItem}
                    onClick={() => {
                        onClick?.();
                    }}
                >
                    <p
                        className={classNames({
                            [styles.navRoute]: true,
                            [styles.active]: pathname === ROUTES.HOME,
                        })}
                    >
                        {isWebsiteDApp ? 'Home' : 'gMAYZ'}
                    </p>
                </div>
            </MyLink>

            {walletStore.isConnected && walletStore.info?.isWalletValidatedWithSignedToken && walletStore.isCoreTeam(true, session, status) ? (
                <>
                    <MyLink href={ROUTES.ADMIN}>
                        <div
                            className={styles.navItem}
                            onClick={() => {
                                onClick?.();
                            }}
                        >
                            <p
                                className={classNames({
                                    [styles.navRoute]: true,
                                    [styles.active]: pathname.startsWith(ROUTES.ADMIN),
                                })}
                            >
                                Admin
                            </p>
                        </div>
                    </MyLink>
                </>
            ) : (
                <></>
            )}

            {walletStore.isConnected ? (
                <>
                    <MyLink href={ROUTES.PORTFOLIO}>
                        <div
                            className={styles.navItem}
                            onClick={() => {
                                onClick?.();
                            }}
                        >
                            <p
                                className={classNames({
                                    [styles.navRoute]: true,
                                    [styles.active]: pathname.startsWith(ROUTES.PORTFOLIO),
                                })}
                            >
                                Portfolio
                            </p>
                        </div>
                    </MyLink>
                </>
            ) : (
                <></>
            )}

            <MyLink href={ROUTES.FAQS}>
                <div
                    className={styles.navItem}
                    onClick={() => {
                        onClick?.();
                    }}
                >
                    <p
                        className={classNames({
                            [styles.navRoute]: true,
                            [styles.active]: pathname === ROUTES.FAQS,
                        })}
                    >
                        Faqs
                    </p>
                </div>
            </MyLink>

            {isRefreshing || appStore.isNavigating === true || appStore.isProcessingTx === true || appStore.isAppStoreLoading === true ? (
                <div className={styles.loadingPage} style={{ left: loaderPosition.left }} ref={loaderRef}>
                    <LoaderButton />
                    {/* {appStore.siteSettings?.debug === true &&
                            toJson({ isRefreshing, isNavigating: appStore.isNavigating, isProcessingTx: appStore.isProcessingTx, isAppStoreLoading: appStore.isAppStoreLoading })} */}
                </div>
            ) : null}
        </div>
    );
}
